/**
 * Whether section-aware editing is on for a block-editor instance.
 *
 * Sections render when the editor instance opts in (`enableSections`) AND
 * either the base release flag (`release-scribe-enable-sections-in-notes`) OR
 * the ambient-copilot flag (`release-scribe-enable-ambient-copilot`) is on. The
 * ambient-copilot cohort has the AX runtime, so they get the sectional-notes
 * experience forced ON — the note is split into mappable fields regardless of the
 * base rollout; it does not bypass the per-instance opt-in.
 */
export const resolveSectionsEnabled = ({
  enableSections,
  enableSectionParser,
  ambientCopilotEnabled,
}: {
  enableSections: boolean;
  enableSectionParser: boolean;
  ambientCopilotEnabled: boolean;
}): boolean => enableSections && (enableSectionParser || ambientCopilotEnabled);
